export var AuthorType;
(function (AuthorType) {
    AuthorType["AGENT"] = "AGENT";
    AuthorType["BOT"] = "BOT";
    AuthorType["CUSTOMER"] = "CUSTOMER";
    AuthorType["SYSTEM"] = "SYSTEM";
})(AuthorType || (AuthorType = {}));
export var AgentStatus;
(function (AgentStatus) {
    AgentStatus["ONLINE"] = "ONLINE";
    AgentStatus["AWAY"] = "AWAY";
})(AgentStatus || (AgentStatus = {}));
